/**
 * Flags emoji category with searchable keywords
 */
export const flags = {
  name: 'Flags',
  icon: '🏳️',
  emojis: [
    { emoji: '🏳️', keywords: ['white', 'flag', 'surrender', 'peace', 'truce'] },
    { emoji: '🏴', keywords: ['black', 'flag', 'pirate', 'waving', 'dark'] },
    { emoji: '🏁', keywords: ['checkered', 'flag', 'race', 'finish', 'racing'] },
    { emoji: '🚩', keywords: ['red', 'flag', 'triangular', 'warning', 'marker'] },
    { emoji: '🏳️‍🌈', keywords: ['rainbow', 'flag', 'pride', 'lgbtq', 'gay'] },
    { emoji: '🏳️‍⚧️', keywords: ['transgender', 'flag', 'trans', 'pride', 'lgbtq'] },
    { emoji: '🏴‍☠️', keywords: ['pirate', 'flag', 'jolly', 'roger', 'skull'] },
    { emoji: '🇺🇸', keywords: ['usa', 'america', 'united', 'states', 'american'] },
    { emoji: '🇬🇧', keywords: ['uk', 'britain', 'british', 'england', 'united', 'kingdom'] },
    { emoji: '🇨🇦', keywords: ['canada', 'canadian', 'maple', 'leaf'] },
    { emoji: '🇦🇺', keywords: ['australia', 'australian', 'aussie', 'oz'] },
    { emoji: '🇩🇪', keywords: ['germany', 'german', 'deutschland'] },
    { emoji: '🇫🇷', keywords: ['france', 'french', 'paris'] },
    { emoji: '🇮🇹', keywords: ['italy', 'italian', 'roma', 'rome'] },
    { emoji: '🇪🇸', keywords: ['spain', 'spanish', 'espana'] },
    { emoji: '🇯🇵', keywords: ['japan', 'japanese', 'nippon', 'tokyo'] },
    { emoji: '🇨🇳', keywords: ['china', 'chinese', 'prc', 'beijing'] },
    { emoji: '🇰🇷', keywords: ['korea', 'korean', 'south', 'seoul'] },
    { emoji: '🇮🇳', keywords: ['india', 'indian', 'delhi', 'mumbai'] },
    { emoji: '🇧🇷', keywords: ['brazil', 'brazilian', 'brasil'] },
    { emoji: '🇲🇽', keywords: ['mexico', 'mexican', 'mexicano'] },
    { emoji: '🇷🇺', keywords: ['russia', 'russian', 'moscow'] },
    { emoji: '🇳🇱', keywords: ['netherlands', 'dutch', 'holland'] },
    { emoji: '🇧🇪', keywords: ['belgium', 'belgian', 'brussels'] },
    { emoji: '🇨🇭', keywords: ['switzerland', 'swiss', 'zurich'] },
    { emoji: '🇦🇹', keywords: ['austria', 'austrian', 'vienna'] },
    { emoji: '🇸🇪', keywords: ['sweden', 'swedish', 'stockholm'] },
    { emoji: '🇳🇴', keywords: ['norway', 'norwegian', 'oslo'] },
    { emoji: '🇩🇰', keywords: ['denmark', 'danish', 'copenhagen'] },
    { emoji: '🇫🇮', keywords: ['finland', 'finnish', 'helsinki'] },
    { emoji: '🇵🇱', keywords: ['poland', 'polish', 'warsaw'] },
    { emoji: '🇵🇹', keywords: ['portugal', 'portuguese', 'lisbon'] },
    { emoji: '🇬🇷', keywords: ['greece', 'greek', 'athens'] },
    { emoji: '🇹🇷', keywords: ['turkey', 'turkish', 'istanbul', 'ankara'] },
    { emoji: '🇮🇱', keywords: ['israel', 'israeli', 'jerusalem', 'telaviv'] },
    { emoji: '🇸🇦', keywords: ['saudi', 'arabia', 'arabian', 'riyadh'] },
    { emoji: '🇦🇪', keywords: ['uae', 'emirates', 'dubai', 'abu', 'dhabi'] },
    { emoji: '🇪🇬', keywords: ['egypt', 'egyptian', 'cairo'] },
    { emoji: '🇿🇦', keywords: ['south', 'africa', 'african', 'johannesburg'] },
    { emoji: '🇳🇬', keywords: ['nigeria', 'nigerian', 'lagos'] },
    { emoji: '🇰🇪', keywords: ['kenya', 'kenyan', 'nairobi'] },
    { emoji: '🇹🇭', keywords: ['thailand', 'thai', 'bangkok'] },
    { emoji: '🇻🇳', keywords: ['vietnam', 'vietnamese', 'hanoi'] },
    { emoji: '🇸🇬', keywords: ['singapore', 'singaporean'] },
    { emoji: '🇲🇾', keywords: ['malaysia', 'malaysian', 'kuala', 'lumpur'] },
    { emoji: '🇮🇩', keywords: ['indonesia', 'indonesian', 'jakarta'] },
    { emoji: '🇵🇭', keywords: ['philippines', 'filipino', 'manila'] },
    { emoji: '🇳🇿', keywords: ['new', 'zealand', 'kiwi', 'auckland'] },
    { emoji: '🇦🇷', keywords: ['argentina', 'argentinian', 'buenos', 'aires'] },
    { emoji: '🇨🇴', keywords: ['colombia', 'colombian', 'bogota'] },
    { emoji: '🇨🇱', keywords: ['chile', 'chilean', 'santiago'] },
    { emoji: '🇵🇪', keywords: ['peru', 'peruvian', 'lima'] },
    { emoji: '🇻🇪', keywords: ['venezuela', 'venezuelan', 'caracas'] },
    { emoji: '🇨🇺', keywords: ['cuba', 'cuban', 'havana'] },
    { emoji: '🇯🇲', keywords: ['jamaica', 'jamaican', 'kingston'] },
    { emoji: '🇮🇪', keywords: ['ireland', 'irish', 'dublin'] },
    { emoji: '🇮🇸', keywords: ['iceland', 'icelandic', 'reykjavik'] },
    { emoji: '🇭🇺', keywords: ['hungary', 'hungarian', 'budapest'] },
    { emoji: '🇨🇿', keywords: ['czech', 'republic', 'prague'] },
    { emoji: '🇺🇦', keywords: ['ukraine', 'ukrainian', 'kyiv', 'kiev'] },
    { emoji: '🇷🇴', keywords: ['romania', 'romanian', 'bucharest'] },
    { emoji: '🇭🇷', keywords: ['croatia', 'croatian', 'zagreb'] },
    { emoji: '🇷🇸', keywords: ['serbia', 'serbian', 'belgrade'] },
    { emoji: '🇧🇬', keywords: ['bulgaria', 'bulgarian', 'sofia'] },
    { emoji: '🇱🇹', keywords: ['lithuania', 'lithuanian', 'vilnius'] },
    { emoji: '🇱🇻', keywords: ['latvia', 'latvian', 'riga'] },
    { emoji: '🇪🇪', keywords: ['estonia', 'estonian', 'tallinn'] },
    { emoji: '🇪🇺', keywords: ['european', 'union', 'eu', 'europe'] },
    { emoji: '🇺🇳', keywords: ['united', 'nations', 'un', 'international'] },
  ],
};

export default flags;

